module.exports = __webpack_public_path__ + "img/entrance_plant_2@3x.a128d8fd.jpg";